import ArrowLeftIcon from "../../icons/ArrowLeftIcon";
import ArrowRightIcon from "../../icons/ArrowRightIcon";
import styled from "styled-components";
import PrettyTitle from "../PrettyTitle/PrettyTitle";

const Wrapper = styled.div`
  display: -webkit-flex;
  flex-direction: row;
  @media (max-width: 768px) {
    justify-content: space-between;
    align-items: center;
    width: 100% !important;
    /* padding: 0 20px; */
    text-align: center;
  }
  gap: ${({ theme }) => theme.spacing.md};
  button {
    transition: all 0.4s;
    border: none;
    cursor: pointer;
    width: ${({ theme }) => theme.spacing.button};
    height: ${({ theme }) => theme.spacing.button};
    background: ${({ theme }) => theme.grey};
    img {
      width: ${({ theme }) => theme.spacing.button};
      height: ${({ theme }) => theme.spacing.button};
    }
    &:disabled {
      img {
        opacity: 0.1;
      }
    }
    &:hover {
      opacity: 0.7;
    }
  }
`;

function SliderArrows({ navigationNextRef, navigationPrevRef, mobile, main }) {
  return (
    <Wrapper>
      <button ref={navigationPrevRef}>
        <ArrowLeftIcon />
      </button>
      {mobile && <PrettyTitle main={main} />}
      <button ref={navigationNextRef}>
        <ArrowRightIcon />
      </button>
    </Wrapper>
  );
}

export default SliderArrows;
